import React from 'react';
import TiPaymentInfo from '../../../PaymentInfo/components/TiPaymentInfo';

const TiPurchaseFlow = ({ onSubmit, errorMessage, props }) => {
  return <TiPaymentInfo onSubmit={onSubmit} errorMessage={errorMessage} {...props} />;
};

export default TiPurchaseFlow;

